import { AccountCategory, type Client } from '@eih-netbroker/common';

export const getClientNormalAccountId = (client?: Client): string | null => {
  return client?.accounts.find(account => account.accountCategory === AccountCategory.Normal)?.accountNumber ?? null;
};
